import mixpanel from 'mixpanel-browser';
mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN, {
  // REACT_APP_MIXPANEL_DEBUG=true logs every track call and send in the console
  debug: process.env.REACT_APP_MIXPANEL_DEBUG === 'true',
});

let actions = {
  identify: (id) => {
    mixpanel.identify(id);
  },
  alias: (id) => {
    mixpanel.alias(id);
  },
  track: (name, props) => {
    mixpanel.track(name, props);
  },
  people: {
    set: (props) => {
      mixpanel.people.set(props);
    },
  },
  track_links: (id, link, props) => {
    mixpanel.track_links(id, link, props);
  }
};

export let Mixpanel = actions;